import { pageTemplateConstants } from "../constants/pageTemplateConstants";

const initialState = {
  sending: false,
  templateList: {},
  templateData: {},
  updateStatus: {},
  contractStatus: {},
  error: {},
};

export default function pageTemplateReducer(state = initialState, action) {
  switch (action.type) {
    case pageTemplateConstants.GET_TEMPLATELIST_REQUEST:
      return {
        sending: true
      };
    case pageTemplateConstants.GET_TEMPLATELIST_SUCCESS:
      return {
        ...state,
        templateList: action.data,
      };
    case pageTemplateConstants.GET_TEMPLATELIST_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case pageTemplateConstants.GET_TEMPLATEDETAIL_REQUEST:
      return {
        sending: true
      };
    case pageTemplateConstants.GET_TEMPLATEDETAIL_SUCCESS:
      return {
        ...state,
        templateData: action.data,
      };
    case pageTemplateConstants.GET_TEMPLATEDETAIL_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case pageTemplateConstants.UPDATE_TEMPLATE_REQUEST:
      return {
        sending: true
      };
    case pageTemplateConstants.UPDATE_TEMPLATE_SUCCESS:
      return {
        ...state,
        updateStatus: action.data,
      };
    case pageTemplateConstants.UPDATE_TEMPLATE_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case pageTemplateConstants.POST_EXECUTE_REQUEST:
      return {
        sending: true
      };
    case pageTemplateConstants.POST_EXECUTE_SUCCESS:
      return {
        ...state,
        contractStatus: action.data,
      };
    case pageTemplateConstants.POST_EXECUTE_FAILURE:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/pageTemplateReducer.js